// extracted by mini-css-extract-plugin
export var fileExt = "_sf-8";
export var fileIcon = "_sf-6";
export var fileLink = "_sf-5";
export var fileName = "_sf-7";
export var image = "_sf-1";
export var imageError = "_sf-3";
export var imageErrorIcon = "_sf-4";
export var imageLink = "_sf-0";
export var imageLoaded = "_sf-2";